import { Box, Button, Icon, Loader, Typography } from "@saviynt/design-system";
import { useCallback, useState } from "react";
import { FormattedMessage } from "react-intl";
import AddUsersModal from "../../components/CreateUserModal";
import UsersTable from "../../components/UsersTable";
import { ListFieldFiltersProvider, useListFieldFilters } from "@repo/ui";
import { SelectionProvider } from "../../contexts/SelectionContext";
import useDebounce from "../../hooks/useDebounce";
import UsersFilters from "../../components/UsersFilters";
import { ViewportProvider } from "../../contexts/ViewportContext";
import { useGetCurrentUserRoles } from "../../shell-components/hooks/useGetCurrentUserRoles";

function IspmUsersContent() {
  const [isOpen, setIsOpen] = useState(false);
  const onClose = useCallback(() => setIsOpen(false), []);
  const { data, isLoading, isError } = useGetCurrentUserRoles();

  const [searchValue, setSearchValue] = useState("");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const { getQueryStringForField } = useListFieldFilters();

  const debouncedSearch = useDebounce(searchValue.trim(), 500);

  const handleAddUsers = useCallback(() => {
    setIsOpen(true);
  }, []);

  if (isLoading) {
    return (
      <Box className="flex justify-center py-10">
        <Loader kind="loop" size="large" format="inline" color="brand" />
      </Box>
    );
  }

  if (isError || !data?.roles?.includes("ROLE_SAV_ISPMADMIN")) {
    return null;
  }

  return (
    <>
      <div className="min-w-0 max-w-full">
        <div
          style={{
            borderBottomColor:
              "var(--color-border-secondary-subtlest, #293950)",
          }}
          className="mb-6 flex items-start justify-between gap-6 border-b border-[#CFD9E9] bg-[var(--color-background-neutral-subtlest,#131d2d)] px-10 py-6"
        >
          <Typography kind="h1">
            <FormattedMessage
              id="OTzaSl"
              defaultMessage="Users"
              description="Users page header title"
            />
          </Typography>
          <Button
            kind="outlined"
            size="small"
            className="shrink-0"
            dataTestId="manage-policies-dashboard-btn"
            onClick={handleAddUsers}
            leftIcon={<Icon kind="Add" />}
          >
            <Typography
              color="--color-foreground-primary-medium"
              kind="body2-bold"
              desktop="body2-bold-d"
              mobile="body2-bold-d"
            >
              <FormattedMessage
                id="wSdb1q"
                defaultMessage="Add Users"
                description="Add Users"
              />
            </Typography>
          </Button>
        </div>

        <Box className="px-10">
          <UsersFilters
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            isFilterOpen={isFilterOpen}
            setIsFilterOpen={setIsFilterOpen}
          />

          <UsersTable
            searchValue={debouncedSearch}
            statusFilter={getQueryStringForField("status")}
            roleFilter={getQueryStringForField("role")}
          />
        </Box>
      </div>
      {isOpen && <AddUsersModal isOpen={isOpen} onClose={onClose} />}
    </>
  );
}

export default function IspmUsers() {
  return (
    <SelectionProvider>
      <ListFieldFiltersProvider>
        <ViewportProvider>
          <IspmUsersContent />
        </ViewportProvider>
      </ListFieldFiltersProvider>
    </SelectionProvider>
  );
}
